import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  G4_P2_S1_L1_Title: {
    id: `guide04.page02.slide01.list01.title`,
  },
  G4_P2_S1_L1_Item1: {
    id: `guide04.page02.slide01.list01.item01`,
  },
  G4_P2_S1_L1_Item2: {
    id: `guide04.page02.slide01.list01.item02`,
  },
  G4_P2_S1_L2_Title: {
    id: `guide04.page02.slide01.list02.title`,
  },
  G4_P2_S1_L2_Item1: {
    id: `guide04.page02.slide01.list02.item01`,
  },
  G4_P2_S1_L2_Item2: {
    id: `guide04.page02.slide01.list02.item02`,
  },
  G4_P2_S1_L3_Title: {
    id: `guide04.page02.slide01.list03.title`,
  },
  G4_P2_S1_L3_Item1: {
    id: `guide04.page02.slide01.list03.item01`,
  },
  G4_P2_S1_L3_Item2: {
    id: `guide04.page02.slide01.list03.item02`,
  },
  G4_P2_S1_WildTrackNote: {
    id: `guide04.page02.slide01.wildTrackNote`,
  },
});
